import {
  CalendarDays,
  ClipboardCheck,
  FileText,
  Handshake,
  Inbox,
  Layers,
  LayoutDashboard,
  Radar,
  ScrollText,
  ShieldCheck,
} from 'lucide-react'
import type { NavSection } from '../types'

/** Fruuit staff navigation (NAV-002, PRD §6.12). Add an entry here and a route in ./routes.tsx. */
export const workspaceNav: NavSection[] = [
  {
    items: [
      { label: 'Dashboard', to: '/workspace', icon: LayoutDashboard, end: true },
      { label: 'Inbox', to: '/workspace/inbox', icon: Inbox },
      {
        label: 'Coverage',
        to: '/workspace/coverage',
        icon: Layers,
        activeFor: ['/workspace/companies'],
      },
      {
        label: 'Engagements',
        to: '/workspace/engagements',
        icon: Handshake,
        activeFor: ['/workspace/cases'],
      },
    ],
  },
  {
    label: 'Research team',
    items: [
      { label: 'Assessments', to: '/workspace/assessments', icon: ClipboardCheck },
      { label: 'Review & release', to: '/workspace/review', icon: ShieldCheck },
      { label: 'Signals', to: '/workspace/signals', icon: Radar },
    ],
  },
  {
    label: 'Records',
    items: [
      {
        label: 'Calendar',
        to: '/workspace/calendar',
        icon: CalendarDays,
        activeFor: ['/workspace/meetings'],
      },
      { label: 'Reports', to: '/workspace/reports', icon: FileText },
      { label: 'Audit', to: '/workspace/audit', icon: ScrollText },
    ],
  },
]
